<template>
  <div class="top">
    <div class="profile-card">
      <div class="profile-container">
        <div class="avatar-container">
          <a-avatar :style="{ color: ' #ffffff !important', 'background-color': user.url ? user.url : '' ? '' : '#C997C5' }" :size="150" :src="user.url" class="text-capitalize">
            {{ user.display_name ? user.display_name[0] : user.user.firstName ? user.user.firstName[0] : "D" }}
          </a-avatar>
        </div>
        <div class="options">
          <button class="threedot-menu-edited" @click="() => (displayDots2 = !displayDots2)">
            <div>
              <font-awesome-icon :style="{ color: '#94A3B8', height: '24px', width: '6px' }" :icon="['fas', 'ellipsis-v']" />
            </div>
            <div :class="`${displayDots2 ? 'menu-content shadow-card active' : 'menu-content shadow-card'}`">
              <p
                class="card-item"
                @click="
                  () => {
                    $refs.ShareProfileModal.showModal()
                  }
                "
              >
                <ShareProfileModal ref="ShareProfileModal" />
                <svg width="20" height="20" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2">
                  <path
                    d="M6.875 6.24976H17.6172L11.4453 1.13257C11.1719 0.898199 11.1719 0.507574 11.3672 0.234137C11.6016 -0.0393009 11.9922 -0.0393009 12.2656 0.156012L19.7656 6.36695C19.8828 6.5232 20 6.71851 20 6.87476C20 7.03101 19.8828 7.22632 19.7656 7.34351L12.2656 13.5544C12.1484 13.6326 11.9922 13.7107 11.875 13.7107C11.6797 13.7107 11.4844 13.6326 11.3672 13.4763C11.1719 13.2029 11.1719 12.8123 11.4453 12.5779L17.6172 7.4607H6.875C3.75 7.4607 1.25 9.9607 1.25 13.0466V14.2576C1.25 14.7263 0.9375 14.9998 0.625 14.9998C0.273438 14.9998 0 14.7263 0 14.3748V13.1638C0 9.3357 3.04688 6.24976 6.875 6.24976Z"
                    fill="black"
                  /></svg
                >Share Profile
              </p>
              <p
                class="card-item"
                @click="
                  () => {
                    $refs.reportContentModal.show('', 15)
                  }
                "
              >
                <ReportContentModal ref="reportContentModal" />
                <font-awesome-icon size="1x" :icon="['fal', 'flag']" class="mr-2 font20" />Report
              </p>
              <p class="card-item" @click="muteUser(currentCircle.id, { id: viewUser.id, role: viewUser.role })">
                <font-awesome-icon :icon="['fal', 'comment-alt-slash']" class="mr-2 w20" />Mute User
              </p>
            </div>
          </button>
        </div>
      </div>
      <div class="options-mob">
        <button class="threedot-menu-edited-mob" @click="() => $refs.drawerShareRef.show()">
          <div>
            <font-awesome-icon :style="{ color: '#94A3B8', height: '24px', width: '6px' }" :icon="['fas', 'ellipsis-v']" />
          </div>
        </button>
      </div>
      <div class="username-container">
        <span class="username text-capitalize">{{ user.display_name ? user.display_name : "nodisplayname" }} </span>
      </div>
      <div class="location-container" v-if="user.location && user.location[0].city">
        <font-awesome-icon size="1x" :style="{ transform: 'scale(1.2)' }" :icon="['fal', 'map-marker-alt']" />
        {{ user.location[0].city }},
        {{ user.location[0].state }}
      </div>
      <div class="seperator"></div>
      <div class="statistics">
        <div class="circle-mem">
          <span class="num">{{ MembersOnCircles }}</span>
          <span class="num-text">Circle Members</span>
        </div>
        <div class="vertical-seperator"></div>
        <div class="circle-on">
          <span class="num">{{ circlesOn }}</span>
          <span class="num-text">Circle On</span>
        </div>
      </div>
    </div>
    <div class="btns-cont">
      <a-button
        :loading="addToCircleInProgress"
        class="dovemed-button font-white ml-4 primary-button btn-btn"
        :style="{ background: user.on_circle ? getSecondaryColor() : getPrimaryColor(), 'pointer-events': user.on_circle ? 'none' : 'all' }"
        @click="addToCircle"
      >
        {{ user.on_circle ? "In your circle" : "Add to Circle" }}
        <i v-if="user.on_circle" class="fa fa-check" aria-hidden="true"></i>
      </a-button>
      <button
        class="dovemed-button font-white ml-4 primary-button btn-btn"
        :style="{
          background: getPrimaryColor(),
        }"
        @click="() => $refs.MessageUserModal.ShowModal(viewUser)"
      >
        Message
      </button>
    </div>
    <MessageUserModal ref="MessageUserModal" />
    <DrawerModal ref="drawerShareRef">
      <div @click="() => $refs.drawerShareRef.close()">
        <p
          class="drawer-item"
          @click="
            () => {
              $refs.ShareProfileModal.showModal()
            }
          "
        >
          <ShareProfileModal ref="ShareProfileModal" />
          <svg width="20" height="20" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2">
            <path
              d="M6.875 6.24976H17.6172L11.4453 1.13257C11.1719 0.898199 11.1719 0.507574 11.3672 0.234137C11.6016 -0.0393009 11.9922 -0.0393009 12.2656 0.156012L19.7656 6.36695C19.8828 6.5232 20 6.71851 20 6.87476C20 7.03101 19.8828 7.22632 19.7656 7.34351L12.2656 13.5544C12.1484 13.6326 11.9922 13.7107 11.875 13.7107C11.6797 13.7107 11.4844 13.6326 11.3672 13.4763C11.1719 13.2029 11.1719 12.8123 11.4453 12.5779L17.6172 7.4607H6.875C3.75 7.4607 1.25 9.9607 1.25 13.0466V14.2576C1.25 14.7263 0.9375 14.9998 0.625 14.9998C0.273438 14.9998 0 14.7263 0 14.3748V13.1638C0 9.3357 3.04688 6.24976 6.875 6.24976Z"
              fill="black"
            /></svg
          >Share Profile
        </p>
        <p
          class="drawer-item"
          @click="
            () => {
              $refs.reportContentModal.show('', 15)
            }
          "
        >
          <ReportContentModal ref="reportContentModal" />
          <font-awesome-icon size="1x" :icon="['fal', 'flag']" class="mr-2 font20" />Report
        </p>
        <p class="drawer-item" @click="muteUser(currentCircle.id, { id: viewUser.id, role: viewUser.role })"><font-awesome-icon :icon="['fal', 'comment-alt-slash']" class="mr-2 w20" />Mute User</p>
      </div>
    </DrawerModal>
  </div>
</template>

<script>
import ReportContentModal from "../Modals/ReportContent.vue"
import { RepositoryFactory } from "../../repositories/RepositoryFactory"
import MessageUserModal from "../Modals/MessageUserModal.vue"
import ShareProfileModal from "../Modals/ShareProfileModal.vue"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faEllipsisV } from "@fortawesome/pro-regular-svg-icons"
import { faFlag } from "@fortawesome/pro-light-svg-icons"
import DrawerModal from "../Modals/DrawerModal.vue"

const UserRepository = RepositoryFactory.get("user")
library.add(faEllipsisV)
library.add(faFlag)

export default {
  name: "ProfileCompletenessView",
  data() {
    return { displayDots3: false, displayDots2: false, addToCircleInProgress: false, profileData: {} }
  },

  props: {
    user: Object,
    circlesOn: Number,
    MembersOnCircles: Number,
    fetch: Function,
  },

  components: {
    ShareProfileModal,
    MessageUserModal,
    ReportContentModal,
    DrawerModal,
  },

  created() {
    console.warn("ProfileCompletenessView.vue created")
    window.addEventListener("mouseup", () => {
      if (this.displayDots2) {
        setTimeout(() => {
          this.displayDots2 = false
        }, 100)
      }
      if (this.displayDots3) {
        setTimeout(() => {
          this.displayDots3 = false
        }, 100)
      }
    })
  },

  methods: {
    handleReportProfile() {
      this.$refs.reportContentModal.show({ id: this.viewUser.id }, 15)
      this.displayDots = false
    },

    addToCircle() {
      this.addToCircleInProgress = true
      UserRepository.addToCircle(this.user, this.currentCircle.id)
        .then(res => {
          UserRepository.getOtherUserProfile(this.user, this.currentCircle.id)
            .then(res => {
              const data = {
                ...res.data.data.user_info,
                on_circle: res.data.data.on_circle,
                request_to_add: res.data.data.request_to_add,
                no_of_members: res.data.data.no_of_members,
              }
              this.$store.commit("User/setViewUser", { data })
              this.fetch()
              this.addToCircleInProgress = false
            })
            .catch(err => {
              this.addToCircleInProgress = false
            })
        })
        .catch(err => {
          this.addToCircleInProgress = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.btns-cont {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 16px;
  margin-top: 32px !important;
  position: absolute !important;
  right: 24px !important;
  @media screen and (max-width: 700px) {
    align-items: normal;
    position: inherit !important;
    margin-top: 105px !important;
  }
}
.btn-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 335px;
  height: 48px !important;
  gap: 5px;
  @media screen and (max-width: 700px) {
    margin-left: 0px !important;
    width: 100%;
  }
}

.divider {
  width: 171px;
  height: 0px;
  border: 0.5px solid #e2e8f0;
  background-color: #e2e8f0;
  margin-left: 16px;
  margin-right: 16px;
}
.card-item {
  font-weight: 400 !important;
  font-size: 16px !important;
  margin-left: 0 !important ;
  line-height: 32px;
  color: #1e2945;
  display: flex;
  align-items: center;
}
.camera-icon-btn {
  // position: absolute;
  // right: 43px;
  // top: 129px;
  // z-index: 10;
  // text-align: right;
  .camera-bttn {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    text-align: center;
    i {
      vertical-align: bottom;
      color: #fff !important;
    }
    input {
      opacity: 0;
      width: 100%;
    }
  }
}
.profile-bg {
  .camera-btn {
    position: absolute;
    bottom: -9%;
    right: 8vw;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.divider {
  margin-bottom: 5px;
  width: 171px;
  height: 0px;
  border: 1px solid #e2e8f0;
}

.profile-header-container {
  display: flex;
  gap: 75px;
}

.dropdown-text {
  font-weight: 500;
  font-size: 16px;
  padding: 10px 20px;
  color: #333333;
  line-height: 24px;
}

.update-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  width: 72px;
  height: 36px;
  text-transform: capitalize;
  color: #ffffff;
  background: #2a71d4;
  border-radius: 6px;
  border: none;
}
.in2 {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  /* identical to box height, or 117% */

  /* Shades/ White */

  color: #ffffff;
}
.in1 {
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  /* Shades/ White */

  color: #ffffff;
}

.instruct {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  width: 191px;
  height: 38px;
}
.update-instruct {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px;
  gap: 8px;
  width: 335px;
  height: 70px;
  background: #062b54;
  border-radius: 4px;
  margin-top: 16px;
  @media screen and (max-width: 700px) {
    width: 100%;
  }
}

.avatar-change-icon {
  z-index: 1;
  position: absolute;
  top: 33px;
  left: 232px;
  cursor: pointer;
}

.tabs:hover {
  color: #2a71d4;
}

.tabs {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;

  height: 48px;

  border-radius: 6px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #0f1734;
}

.profile-tab {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  position: absolute;
  width: 732px;
  height: 48px;
  left: 520px;
  top: 489px;
  @media screen and (max-width: 700px) {
    top: 1280px;
    left: 20px;
    overflow-x: scroll;
  }
}

.profile-tab::-webkit-scrollbar {
  @media screen and (max-width: 700px) {
    width: 0 !important;
  }
}
.edit-status-info-container-last {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  width: 100%;
  height: 40px;
}

.profile-edit-header {
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #33415f;
}

.profile-edit-header-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 8px;
  gap: 10px;

  width: 334px;
  height: 40px;
}

.profile-edit-contanier {
  @media screen and (max-width: 700px) {
    width: 100%;
  }
}
.button-text {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  color: #2a71d4;
  cursor: pointer;
}

.edit-button {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 16px;
  gap: 10px;
  width: 80px;
  height: 32px;
  color: #2a71d4;
  background: #e1eaf7;
  border-radius: 8px;
}

.edit-status-info-container {
  /* display: flex;
  flex-direction: row; */
  align-items: flex-start;
  padding: 8px;
  gap: 10px;

  width: 214px;
  height: 40px;
}

.edit-status-info {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #33415f;
  gap: 10px;
}

.green-tick {
  width: 20px;
  height: 20px;
}

.sub-profile-edit-even {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;
  background: #f1f5f9;
  width: 334px;
  height: 56px;
}

.sub-profile-edit {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;

  width: 334px;
  height: 56px;
}

.profile-completion-status {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 11px;
  width: 335px;
  height: 60px;
}

/* 
  .custom-progress .ant-progress-outer{
  padding: 0px !important;
  } */

// .custom-progress .any-progress-line{
//   font-size: 20px;
// }

// .custom-progress .ant-progress-text{
//   font-style: normal;
//   font-weight: 700;
//   font-size: 20px;
//   line-height: 30px;
//   text-align: right;
//   color: #647490;
// }

// .custom-progress .ant-progress-bg{
//   background-color: #2A71D4;
// }

.profile-header {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #33415f;
}

.percentage-indicator {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  padding: 0px;
  width: 40px;
  height: 30px;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  text-align: right;
  color: #647490;
}

.loader-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 16px;

  width: 335px;
  height: 30px;
}

.vertical-seperator {
  width: 1px;
  height: 36px;
  background: #cbd5e1;
}

.num {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  color: #0f1734;
}

.num-text {
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #94a3b8;
}

.circle-on {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;

  width: 159.01px;
  height: 44px;
}

.circle-mem {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;

  width: 159.01px;
  height: 44px;
}

.statistics {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  padding: 24px 8px;
  width: 335px;
  height: 92px;
  background: #ffffff;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  @media screen and (max-width: 700px) {
    width: 100%;
  }
}

.seperator {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 8px 0px;

  width: 335px;
  height: 16px;
}

.location-text {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #0f1734;
}

.location-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 0px;
  width: 100%;
  justify-content: flex-start;
  height: 24px;
}

.username {
  font-style: normal;
  font-weight: 700;
  font-size: 36px;
  line-height: 46px;
  color: #0f1734;
}

.username-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  width: 335px;
  @media screen and (max-width: 700px) {
    width: 100%;
  }
}

.options-mob {
  display: none;
  @media screen and (max-width: 700px) {
    display: flex;
    justify-content: flex-end;
    margin-right: 40px;
    margin-top: -45px;
    width: 100%;
    cursor: pointer;
  }
}

.options {
  width: 6px;
  height: 24px;
  cursor: pointer;
  @media screen and (max-width: 700px) {
    display: none;
  }
}

.avatar {
  width: 160px;
  height: 160px;
  cursor: pointer;
}

.avatar-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;

  width: 309px;
  height: 160px;
}

.profile-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-start;
  padding: 0px;

  width: 315px;
  height: 160px;
}

.top {
  @media screen and (max-width: 700px) {
    width: 100%;
  }
}

.profile-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;
  width: 335px;
  @media screen and (max-width: 700px) {
    position: relative;
    top: 64px;
    align-items: center;
    width: 100%;
  }
}

.profile-card-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 24px;
  position: absolute;
  width: 383px;
  left: 120px;
  min-height: 619px;
  top: 337px;
  background: #ffffff;
  box-shadow: 0px -8px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.banner-image {
  position: absolute;
  width: 1440px;
  height: 400px;
  left: 0px;
  top: 65px;
}
</style>



// WEBPACK FOOTER //
// src/components/commons/ProfileCompletenessView.vue